import { render, staticRenderFns } from "./NameIcon.vue?vue&type=template&id=6f33f8b0&scoped=true&"
import script from "./NameIcon.vue?vue&type=script&lang=ts&"
export * from "./NameIcon.vue?vue&type=script&lang=ts&"
import style0 from "./NameIcon.vue?vue&type=style&index=0&id=6f33f8b0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f33f8b0",
  null
  
)

export default component.exports